import {isNil} from 'ramda';

import {AuctionVehicleDetailResponseBody} from '../types';

const stripCurrencyPrefix = (value: string | null | undefined): string | null | undefined => {
  if (isNil(value)) {
    return value;
  }

  return value.replace(/^CURRENCY_/, '');
};

export function normalizeAuctionCurrencies(
  vehicle: AuctionVehicleDetailResponseBody
): AuctionVehicleDetailResponseBody {
  return {
    ...vehicle,
    auctionVehicle: {
      ...vehicle.auctionVehicle,
      currency: stripCurrencyPrefix(vehicle.auctionVehicle.currency),
      originalCurrency: stripCurrencyPrefix(vehicle.auctionVehicle.originalCurrency),
    },
  };
}
